<!--
  @compontent
  Lazy load component when a promise is resolved.
  A shortcut for IntersectionObserver and prosmie resolver
-->
<script>import IntersectionObserver from "../v6/IntersectionObserver/IntersectionObserver.svelte";
export let promise;
</script>

<IntersectionObserver margin="50% 0px" once let:intersecting>
  {#if !intersecting}
    <slot name="loading" />
  {:else}
    {#await promise}
      <slot name="loading" />
    {:then data}
      <slot {data} />
    {/await}
  {/if}
</IntersectionObserver>
